export * from './environment';
export * from './path';
export { ERROR_MESSAGE } from './message';

export const MAX_ADDITIONAL_SCORE = 30;
